import { AppIcons } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Typography, Box, SxProps, Theme } from '@mui/material';

import { LineIconItem } from './LineIconItem';
import { ScoopSummaryItem, ScoopStatItem } from './types';

const SCOOP_STRINGS = appStrings.modules.resourceWrapper.scoop;

type TheScoopProps = Readonly<{
  summaryItems: ScoopSummaryItem[];
  statItems: ScoopStatItem[];
}>;

export const TheScoop = ({ summaryItems, statItems }: TheScoopProps) => {
  return (
    <Box sx={containerSx}>
      <Box sx={titleContainerSx}>
        <Typography variant="display-sm-medium">{SCOOP_STRINGS.title}</Typography>
      </Box>

      <Box sx={contentContainerSx}>
        <Box sx={summaryContainerSx}>
          {summaryItems.map((item, index) => (
            <Box key={index}>
              <Typography variant="text-md-bold" color={({ backrs }) => backrs.colors['Brand/500']}>
                {item.title}:{' '}
              </Typography>
              <Typography variant="text-md-regular">{item.description}</Typography>
            </Box>
          ))}
        </Box>

        <Box sx={statsInfoContainerSx}>
          {statItems
            .filter((item) => item.text !== '')
            .map((item, index) => (
              <LineIconItem
                key={index}
                title={item.title}
                iconName={item.iconName as AppIcons}
                text={item.text}
                {...(item.infoModalProps && {
                  content: {
                    type: 'INFO_MODAL',
                    infoModalProps: item.infoModalProps,
                  },
                })}
              />
            ))}
        </Box>
      </Box>
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  mb: backrs.spacing['spacing-6xl'],
  borderTop: {
    xs: `1px solid ${backrs.colors['Colors/Foreground/fg-quaternary']}`,
    sm: 'none',
  },
  marginX: backrs.spacing['spacing-4xl'],
  '@media (max-height: 768px)': {
    mx: backrs.spacing['spacing-4xl'],
  },
  '@media (max-width: 414px)': {
    mx: backrs.spacing['spacing-2xl'],
  },
});

const titleContainerSx: SxProps<Theme> = ({ backrs }) => ({
  paddingY: backrs.spacing['spacing-3xl'],
  gap: backrs.spacing['spacing-xxs'],
});

const contentContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: { xs: 'column-reverse', sm: 'row' },
  gap: backrs.spacing['spacing-4xl'],
});

const summaryContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-2xl'],
  width: { sm: '66%' },
});

const statsInfoContainerSx: SxProps<Theme> = ({ backrs }) => ({
  display: {
    xs: 'grid',
    sm: 'flex',
  },
  gridTemplateColumns: {
    xs: 'repeat(2, 1fr)',
    sm: '1fr',
  },
  flexDirection: {
    xs: 'row',
    sm: 'column',
  },
  gap: backrs.spacing['spacing-3xl'],
  width: { sm: '33%' },
});
